export default __webpack_public_path__ + "static/media/approvalDelegation.1caeefe7.svg";